import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  zones,
  zonesForm,
  ubications,
  ubicationsForm,
  objects,
  objectsForm,
  reports,
  reportsForm,
  responsibles,
  responsiblesForm,
} from "./Reducers";

export default combineReducers({
  responsibles,
  responsiblesForm,
  reports,
  reportsForm,
  objects,
  objectsForm,
  ubications,
  ubicationsForm,
  zones,
  zonesForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
